import React, { ReactNode } from "react";
import { CrossCircle } from "./icons/CrossCircle";

export const SubscriptionAccessLossPoints = ({
  points,
}: {
  points: (string | ReactNode)[];
}) => {
  return (
    <div className="t-mt-5 t-space-y-3">
      <div className="t-text-subtext-sm t-text-text-60">
        Here’s what you’ll lose access to
      </div>
      <div className="t-space-y-2">
        {points.filter(Boolean).map((point, index) => (
          <div className="t-flex t-items-center t-gap-1" key={index}>
            <div className="t-text-red -t-mt-1">
              <CrossCircle />
            </div>
            <span className="t-text-body-sm t-text-text-30">{point}</span>
          </div>
        ))}
      </div>
    </div>
  );
};
